import React from 'react';

import images from './Images';
import styles from './Thumbnail.module.css';

interface IProps {
  selectedThumbnail: string;
  color: string;
  shade: string;
  setThumbnail: (thumbnail: string) => void;
  thumbnailImg: string | null;
  useTemplate: boolean;
  selectCustomThumbnail: () => void;
}

// color and shade controls are now unused, remove at some point

const ThumbnailSelector: React.FC<IProps> = ({
  selectedThumbnail,
  color,
  shade,
  setThumbnail,
  thumbnailImg,
  useTemplate,
  selectCustomThumbnail,
}) => (
  <div className={styles.thumbnailImagesBox}>
    <ul>
      {/*{thumbnailImg && (
        <li
          className={useCustomThumbnail ? styles.selectedThumbnailImage : ''}
          onClick={selectCustomThumbnail}
        >
          <img
            key="custom"
            src={thumbnailImg}
            alt="custom"
            className={styles.thumbnailImage}
          />
        </li>
      )}*/}
      {images.slice(0, 6).map(image => (
        <li
          key={image.id}
          onClick={() => setThumbnail(image.id)}
          style={{
            cursor: 'pointer',
          }}
          className={
            useTemplate && selectedThumbnail === image.id
              ? styles.selectedThumbnailImage
              : ''
          }
        >
          <img
            key={image.id}
            src={image.src}
            alt={image.alt}
            className={styles.thumbnailImage}
          />
        </li>
      ))}
    </ul>
  </div>
);

export default ThumbnailSelector;
